<template>
  <div>
    <v-card-title class='pa-0 pl-3 pt-1'>
      <div class="pa-0 px-1 font-weight-bold pt-2 text-h6 primary--text" v-if="!no_title">
        <v-icon color="primary">mdi-calendar</v-icon>
        {{ event_info.category == 'event'  ? 'Evento' : 'Bloqueio de agenda' }}
      </div>
    </v-card-title>
    <v-card-text class="px-0">
      <div class="ml-7">
        <div class="pa-0 px-1 font-weight-bold pt-2">Nome do evento:</div>
        <div class="pa-0 px-3">{{event_info.name}}</div>
        <div class="pa-0 px-1 font-weight-bold pt-2">Tamanho:</div>
        <div class="pa-0 px-3">{{event_info.size == 'small' ? 'Pequeno' : event_info.size == 'medium' ? 'Médio' : 'Grande'}}</div>
        <!-- <div class="pa-0 px-1 font-weight-bold pt-2">Local do evento:</div> -->
        <!-- <div class="pa-0 px-3">{{event_info.place}}</div>  -->
        <!-- <div class="pa-0 px-1 font-weight-bold pt-2">CEP:</div> -->
        <!-- <div class="pa-0 px-3">{{event_info.event_detail.zip}}</div> -->
        <!-- <div class="pa-0 px-1 font-weight-bold pt-2">Endereço:</div> -->
        <!-- <div class="pa-0 px-3">{{event_info.event_detail.address}}</div> -->
        <div class="pa-0 px-1 font-weight-bold pt-2">Início do evento: </div>
        <div class="pa-0 px-3">{{this.$dayjs(event_info.start_at).add(12,'h').format('LL')}}</div>        
        <div class="pa-0 px-1 font-weight-bold pt-2">Termino do evento: </div>
        <div class="pa-0 px-3">{{ event_end_date }}</div>
        <div class="pa-0 px-1 font-weight-bold pt-2" v-if="event_info.description">Descrição do evento: </div>
        <div class="pa-0 px-3" v-if="event_info.description">{{event_info.description}}</div>        
      </div>
    </v-card-text>
  </div>
</template>
<script>
  export default {
    name: 'SummaryInfo',
    props: {
      event_info: {
        type: Object,
      },
      no_title:{
        type: Boolean,
        default: false,
      }
    },
    computed: {
      event_end_date() {
        if(this.event_info.end_at){
          return this.$dayjs(this.event_info.end_at).add(12,'h').format('LL')
        }else{
          return ' '
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>